import { VariableType } from '../Enums/variable-type';

export class RestApiResponseVariableConfiguration {
    public id: number;
    public name: string;
    public type: VariableType;
    public value: string;

    /**
     * Retourne une copie d'une instance de RestApiResponseVariableConfiguration
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: RestApiResponseVariableConfiguration) {
        if (!!other) {
            const instance = new RestApiResponseVariableConfiguration();
            instance.id = other.id;
            instance.name = other.name;
            instance.type = other.type;
            instance.value = other.value;

            return instance;
        } else {
            return null;
        }
    }

    /**
     * Retourne une copie d'un tableau d'instances de RestApiResponseVariableConfiguration
     * @param other : Tableau source.
     * @returns : Copie du tableau.
     */
    public static cloneArray(others: RestApiResponseVariableConfiguration[]) {
        if (!!others) {
            let variables: RestApiResponseVariableConfiguration[] = [];

            others.forEach((x) => {
                const variable = RestApiResponseVariableConfiguration.clone(x);
                variables.push(variable);
            });

            return variables;
        } else {
            return [];
        }
    }
}
